import { css } from "@emotion/css";
import { Divider } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import type { DeploymentFreezeDetailEnvironment, DeploymentFreezeScopeDetail, ProjectResource } from "@octopusdeploy/octopus-server-client";
import pluralize from "pluralize";
import React from "react";
import type { DoBusyTask } from "~/components/DataBaseComponent";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import { NoResults } from "~/components/NoResults/NoResults";
import { FormSectionHeading } from "~/components/form/index";
import { DeploymentFreezeTenantScopeTable } from "./DeploymentFreezeTenantScopeTable";
import type { DeploymentFreezeModel } from "./EditDeploymentFreeze";
import ConnectFreezeTenantsDialog from "./ScopeConnectDialog/ConnectFreezeTenantsDialog";
interface FreezeTenantScopeSectionProps {
    model: DeploymentFreezeModel;
    project?: ProjectResource;
    focussedScopeCellId: string;
    onConnected: (model: DeploymentFreezeModel) => void;
    onTenantEnvironmentUpdate: (projectScope: DeploymentFreezeScopeDetail, selectedEnvironments: DeploymentFreezeDetailEnvironment[], tenantId?: string) => Promise<boolean>;
    onTenantRemove: (projectEnvironmentScope: DeploymentFreezeScopeDetail, tenantId: string) => void;
    onFocusedScopeCell: (id: string) => void;
    onScopeCellLostFocus: () => void;
    doBusyTask: DoBusyTask;
}
export const FreezeTenantScopeSection = (props: FreezeTenantScopeSectionProps) => {
    const { model, focussedScopeCellId, onConnected, onTenantEnvironmentUpdate, onTenantRemove, onFocusedScopeCell, onScopeCellLostFocus, doBusyTask } = props;
    const buildTenantScopeSummary = () => (model.tenantScopes.length > 0 ? `${pluralize("tenant", model.tenantScopes.length, true)} assigned` : "Assign tenants to this deployment freeze.");
    return (<div>
            <FormSectionHeading title="Tenant Scope" key="tenantScope"/>
            <div className={styles.connectScopesRow}>
                <span>{buildTenantScopeSummary()}</span>
                {model.tenantScopes.length === 0 && <NoResults />}
                <OpenDialogButton label="Assign Tenants">
                    <ConnectFreezeTenantsDialog deploymentFreeze={model} onConnected={(freeze: DeploymentFreezeModel) => onConnected(freeze)} project={props.project} hideSelectProjectStep={props.project !== undefined} alreadyConnectedTenantIds={model.tenantScopes.map((t) => t.Id)}/>
                </OpenDialogButton>
            </div>
            {model.tenantScopes.length > 0 && (<React.Fragment>
                    <Divider />
                    <DeploymentFreezeTenantScopeTable key="scopeTableTenant" scopeType="Tenant" scopeDetails={model.tenantScopes} onEnvironmentUpdate={onTenantEnvironmentUpdate} onRemove={onTenantRemove} doBusyTask={doBusyTask} focussedScopeCellId={focussedScopeCellId} onFocusedScopeCell={onFocusedScopeCell} onScopeCellLostFocus={onScopeCellLostFocus} hideProject={props.project !== undefined}/>
                </React.Fragment>)}
        </div>);
};
const styles = {
    connectScopesRow: css({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        margin: space[16],
    }),
};
